import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/6.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Ścieżka pod lasem"
            question=""
            audio={audio}
            answers={{
                ans1: "Dalej",
            }}
            links={{
                link1: PAGES.p5,
            }}
            content={
                <div>
                    <p>
                        Co to za dźwięk? Za świerkami biegnie szosa, a jej środkiem drepczą setki, tysiące białych ptaków! Przechodzisz na przełaj przez świerkowy zagajnik  – w końcu nie każdego dnia można zobaczyć przemarsz gęsiej armii! Oprócz gardłowego gęgania jest jeszcze coś… Gęsi tupią, jak gdyby każda miała podkute żołnierskie buty. Kiedy czereda znika między świerkami, ruszasz w stronę miasteczka.
                    </p>
                    <ul>
                        <li>
                            Czyli to prawda, że tutaj gęsi chodzą podkute jak konie? – mówisz do siebie.
                        </li>
                    </ul>
                    <p>
                        Idąc wzdłuż zagajnika, nagle zauważasz kamienny nagrobek, a za nim kolejne. To cmentarz ewangelicki. Cały porośnięty konwaliami. Mijając go, zastanawiasz się, co jest dziwniejsze: tysiące białych podkutych gęsi, czy tysiące białych kwiatów pamięci porastających tajemniczy cmentarz.
                    </p>
                </div>
            }
        />

    );
}